import React from 'react'
import './Topbar.css'
import {BsPlus} from "react-icons/bs"
import Singleselect from '../Singleselect/Singleselect'
import SortByjson from '../Singleselect/filteredBy'
import Searchs from '../Search/Searchs'

const Topbarsub = ({serchCriteria, newEmployee, currrenTab, searchword, addoverlay, role}) => {
  console.log(role)

  const handleSelected = (incoming) =>{
    serchCriteria(incoming)
  }

  const handleNewEmp = () =>{
    newEmployee()
  }

  const searchWord = (incoming) =>{
    console.log(incoming)
    searchword(incoming)
  }

  const handleNewOverlay = (e) =>{
    // console.log(e.target.id)
    addoverlay({tag: e.target.id})
  }

  return (
    <div className='topbarsub-container'>
      <div className='topbarsub-mid-container'>
        {currrenTab !== "task" && <Singleselect socialjs={SortByjson} selectedSocVal={handleSelected} placeholder="Search by"/>}
        {currrenTab !== "task" && <Searchs searchval={searchWord}/>}
        {currrenTab !== "task" && <button className='treted-search'>Search</button>}
      </div>

      {currrenTab === "employee" ? <div className='create-notice-container'>
        <BsPlus id='cnc-id-plus'/>
        <span>New Employee</span>
        <div id='newemployee' className='btn-overlay-leaf' onClick={handleNewOverlay} />
      </div> : currrenTab === "department" ? <div className='create-notice-container'>
        <BsPlus id='cnc-id-plus'/>
        <span>New Department</span>
        <div id='newdepartment' className='btn-overlay-leaf' onClick={handleNewOverlay} />
      </div> : currrenTab === "country" ? <div className='create-notice-container'>
        <BsPlus id='cnc-id-plus'/>
        <span>New Country</span>
        <div id='newcountry' className='btn-overlay-leaf' onClick={handleNewOverlay} />
      </div> : currrenTab === "region" ? <div className='create-notice-container'>
        <BsPlus id='cnc-id-plus'/>
        <span>New Region</span>
        <div id='newregion' className='btn-overlay-leaf' onClick={handleNewOverlay} />
      </div> : currrenTab === "role" ? <div className='create-notice-container'>
        <BsPlus id='cnc-id-plus'/>
        <span>New Role</span>
        <div id='newrole' className='btn-overlay-leaf' onClick={handleNewOverlay} />
      </div> : currrenTab === "kpi" ? <div className='create-notice-container'>
        <BsPlus id='cnc-id-plus'/>
        <span>NEW KPI</span>
        <div id='newkpi' className='btn-overlay-leaf' onClick={handleNewOverlay} />
      </div> : currrenTab === "event" && role !== "STAFF" ? <div className='create-notice-container'>
        <BsPlus id='cnc-id-plus'/>
        <span>Create Event</span>
        <div id='event' className='btn-overlay-leaf' onClick={handleNewOverlay} />
      </div> : currrenTab === "task" && role !== "STAFF" ? <div className='create-notice-container'>
        <BsPlus id='cnc-id-plus'/>
        <span>New Task</span>
        <div id='task' className='btn-overlay-leaf' onClick={handleNewOverlay} />
      </div> : <></>}
    </div>
  )
}

export default Topbarsub